import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const Heading = styled.div`
    font-size: 39px;
    color: #130e4a;
    font-family: 'AvenirNextWorld Demi';
    opacity: 1;
    width: 200px;
    height: 50px;
    text-align: left;
    ${media.mobileDevice`
        font-size:40px;
        height:50px;
    `}
`;
export const SubHeading = styled.div`
    font-family: AvenirNextWorld Bold;
    color: ${({ color }) => (color ? color : '#1010EB')};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '0px'};
    ${media.mobileDevice`
       margin-bottom:8px;
    `}
`;
export const StyledHorizontalRow = styled.hr`
    width: 97%;
    opacity: 0.36;
    color: #ffffff;
    background-color: #ffffff;
    ${media.smalDevice`
        display: block;
    `}
    ${media.mobileDevice`
        display: block;
        width: 90%;
        opacity: 0.36;
        color: #ffffff;
    `}
    &:last-child {
        display: none;
    }
`;
